import React, { useCallback, useEffect, useState } from 'react';
import DataGrid from '../../../../table/DataGrid';
import FormatDate from '../../../../date/FormatDate';
import IconTooltipButton from '../../../../button/IconTooltipButton';
import { getMaintenanceLogsSkipAndLimit } from '../../../../../services/maintenance/maintenance.service';
import { useSelector } from 'react-redux';
import PreviewDialog from '../../../Audit/Preview/Dialog';
import { Chip } from '@mui/material';

const List = () => {
  const [list, setList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, toggleLoading] = useState(true);
  const [show, setShow] = useState(null);
  const stateFilter = useSelector((state) => state?.filter?.maintenance.filter);
  const skip = useSelector((state) => state?.datatable?.maintenance?.skip || 0);
  const rowsPerPage = useSelector((state) => state?.datatable?.maintenance?.rowsPerPage || 100);
  const columnsTable = useSelector((state) => state?.datatable?.maintenance?.columnsTable || []);

  const loadData = useCallback(
    async (rowsPerPage, skip, filterData) => {
      try {
        toggleLoading(true);
        const filter = {
          ...filterData,
          action: filterData?.action ? filterData?.action : ['sync maintenance', 'disable maintenance']
        };
        const result = await getMaintenanceLogsSkipAndLimit(skip, rowsPerPage, filter);
        const { data, count } = result.data;
        setList(data || []);
        setTotalRows(count);
      } finally {
        toggleLoading(false);
      }
    },
    []
  );

  useEffect(() => {
    loadData(rowsPerPage, skip, stateFilter);
  }, [loadData, rowsPerPage, skip,stateFilter]);

  const colorStatus = (status) => {
    switch (status) {
      case 'success':
        return 'success';
      case 'failed':
        return 'error';
      case 'executing':
        return 'info';
      default:
        return 'warning';
    }
  }
  return (
    <>
      <DataGrid
        id='maintenance-logs'
        rows={list.map((row, index) => ({
          ...row,
          index: index + 1 + rowsPerPage * skip,
          date: <FormatDate date={row.createdAt} pattern='dd/MMM/yyyy hh:mm a' />,
          ip: row.ip,
          module: `${row.userType || ''} ${row.module}`,
          action: row.action,
          status: <Chip size='small' label={row.status} className='uppercase' color={colorStatus(row.status)} />,
          user: <div>
            <div>{row.user?.fullName}</div>
            <div className='text-sm opacity-50'>{row.user?.roles?.map((role) => role.name).join(', ')}</div>
          </div>,
          actions: (
            <div className='flex items-center gap-4 items-center justify-center'>
              <IconTooltipButton title='Preview' icon='expand-alt' onClick={() => setShow(row._id)} />
            </div>
          )
        }))}
        loading={loading}
        totalRows={totalRows}
        skip={skip}
        rowsPerPage={rowsPerPage}
        columns={[
          { label: '#', key: 'index', align: 'center', width: 10, show: true, hide: false },
          ...columnsTable,
          { label: 'Actions', key: 'actions', align: 'center', width: 50, show: true, hide: false }
        ]}
        nameModule='maintenance'
        labelNoRows="You don't have any logs yet"
      />
      {show && <PreviewDialog show={show} onClose={() => setShow(false)} type='maintenance' />}
    </>
  );
};

export default List;
